import { notification } from 'antd';
import style from "./css/Alert.module.css";
import { Block, Warn } from "./images/icon";

notification.config({
  // placement: 'bottom',
  // bottom: 0
  top: 70
});

interface IProps {
  text: string,
  status?: number | string,
  time?: any,
  back?: () => void,
  btnText?: string | boolean,
  btnBack?: () => void,
}
class Widgets {
  /**
   * @name 封装的弹窗组件
   * @param { string } text 弹窗所显示的文字
   * @param { number | string } status 弹窗类型: 200(正确),400(错误),0(加载中),100(添加一层判断，判断成功执行回调函数),default(错误)
   * @param { any } time 弹窗显示的时间;单位:秒(默认2s),当为null时无限时长
   * @param { any } back 弹窗关闭时执行的事件
   * @param { string | boolean } btnText 弹窗的按钮文字，不填写默认不显示
   * @param { any } btnBack 点击弹窗的按钮后执行的事件
   * @returns 失败，成功，加载中，确认按钮弹窗
   */
  Alert = (data: IProps) => {
    const { text, status, time = 2, back, btnText, btnBack } = data;
    let Style: any = {
      width: 320,
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.2)",
      padding: 0,
      background: "rgba(255, 252, 242, 0.95)",
    };
    let message = (v?: number) => (<>
      <div className={style.left}>
        {(v === 400) && <Warn />}
        <span className={style.text}>{text}</span>
      </div>
      {btnText && <button className={style.btn} onClick={btnBack}>{btnText}</button>}
    </>)
    let type;
    switch (status) {
      case 200:
        type = message()
        break;
      case 400:
        type = message(400)
        break;
      case 0:
        type = message(200)
        break;
      default:
        type = message(400)
        break;
    }
    notification.open({
      duration: time,
      description: <div className={`${style.box}`}>
        {type}
      </div>,
      onClose: back,
      message: <></>,
      style: Style,
      closeIcon: <Block />
    });
  };

  destroy = () => {
    notification.destroy()
  }
}

const Toast = new Widgets();
export default Toast;
